import { Auth } from 'aws-amplify'

export function changeEmail(email: string): Promise<string | void> {
  return Auth.currentAuthenticatedUser().then((user) => {
    return Auth.updateUserAttributes(user, { email })
  })
}
